module.exports = __webpack_public_path__ + "static/img/LedRGB-1.6faa25b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/LedRGB-1.svg
// module id = G+Cq
// module chunks = 0